import axios from './axios';

async function updateVdnMap(agentId, vdnMapJson, versionName, versionDescription) {
  return axios.put(`/agents/${agentId}/management/vdn-map`, {
    vdn_map: vdnMapJson,
    version_name: versionName,
    version_description: versionDescription
  });
}

async function getVdnMapVersions(agentId) {
  return axios.get(`/agents/${agentId}/management/vdn-map/versions`);
}

async function getVdnMapVersionById(agentId, versionId) {
  return axios.get(`/agents/${agentId}/management/vdn-map/versions/${versionId}`);
}

export default {
  updateVdnMap,
  getVdnMapVersions,
  getVdnMapVersionById,
};
